import { cn } from "@/lib/utils";

interface CornerBracketsProps {
  children: React.ReactNode;
  className?: string;
}

export const CornerBrackets = ({ children, className }: CornerBracketsProps) => (
  <div className={cn("relative inline-block", className)}>
    {/* Top-left bracket */}
    <span
      className="absolute -top-2 -left-3 w-[6px] h-[6px] border-l border-t border-accent/20"
      aria-hidden="true"
    />
    {/* Bottom-right bracket */}
    <span
      className="absolute -bottom-2 -right-3 w-[6px] h-[6px] border-r border-b border-accent/20"
      aria-hidden="true"
    />
    {children}
  </div>
);
